import SurveyStepActionsKpiContainer from "./SurveyStepActionsKpiContainer";
export default SurveyStepActionsKpiContainer;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepActionsKpi/index.js